import {
  Injectable,
  Output,
  EventEmitter,
  signal,
  ChangeDetectorRef,
  NgZone,
  inject,
  ApplicationRef,
} from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";
import { map } from "rxjs/operators";
import { HeaderService } from "./header.service";

@Injectable({
  providedIn: "root",
})
export class StringService {
  public strings: any = {};
  public connectionStrings: any = {};

  private readonly ngZone = inject(NgZone);
  private readonly appRef = inject(ApplicationRef);

  constructor(
    private cookie: CookieService,
    private http: HttpClient,
    private api: ApiService,
    private headers: HeaderService,
  ) {}

  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() connectionStringsChange: EventEmitter<any> = new EventEmitter();

  toggle(strings: any) {
    this.strings = strings;
    this.change.emit(strings);
    this.scheduleChangeDetection();
  }

  toggleConnectionStrings(strings: any) {
    this.connectionStrings = strings;
    this.connectionStringsChange.emit(strings);
    this.scheduleChangeDetection();
  }

  /**
   * Force a change-detection pass on the next microtask so that all
   * child components re-evaluate templates that read the plain
   * `strings` / `connectionStrings` fields. This is the v22
   * standalone-architecture equivalent of the parent->child CD
   * propagation the old NgModule architecture did for free.
   */
  private scheduleChangeDetection(): void {
    // Defer to the next macrotask so we're outside the current
    // CD cycle (avoids ExpressionChangedAfterItHasBeenCheckedError).
    setTimeout(() => {
      this.ngZone.run(() => this.appRef.tick());
    }, 0);
  }

  public getStrings(language?: string, connect?: boolean) {
    if (language === undefined || language === "") {
      language = this.cookie.get("language");
      if (language === undefined || language === "") {
        language = navigator.language;
        language = language.split("-")[0];
      }
    }
    let location = !connect
      ? this.api.GET_STRINGS
      : this.api.GET_CONNECTION_STRINGS;
    this.cookie.set(
      "language",
      language,
      60 * 60 * 24 * 30,
      "/",
      "/",
      true,
      "None",
    );
    return this.http
      .get<any>(location + "/" + language, this.headers.getOptions())
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
}
